export const LinkParser = {
  getFirmLinkOrigin: link => {
    const regExp = new RegExp(/^(f|ht)tps?:\/\//i);
    link = regExp.test(link) ? link : `http://${link}`;
    const parser = document.createElement('a');
    parser.href = link;
    return parser.hostname;
  },

  findUrls: str => {
    return str.match(
      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g
    );
  },

  getHostName: str => {
    const [, hostname] = str.match(/^https?:\/\/([^/?#]+)(?:[/?#]|$)/i) || [];
    return hostname;
  },

  // parser.href = "http://example.com:3000/pathname/?search=test#hash";
  // parser.protocol; // => "http:"
  // parser.host; // => "example.com:3000"
  // parser.hostname; // => "example.com"
  // parser.port; // => "3000"
  // parser.pathname; // => "/pathname/"
  // parser.hash; // => "#hash"
  // parser.search; // => "?search=test"
  // parser.origin; // => "http://example.com:3000"
};

export default LinkParser;
